import { Stack, Typography, Box } from "@mui/material";
import { CustomButton } from "../ui/CustomButton";
import { CompanyIcon } from "../images/CompanyIcon";
import { Campaign } from "../../types/apiTypes";
import { Link, useNavigate } from "react-router-dom";
import { AppRoutes } from "../../types/enums";
import { formatDateRange } from "../../utils/formatDateRange";
import { RolesIconsBlock } from "./RolesIconsBlock";
import { NewCampaignBlock } from "./NewCampaignBlock";

export const ProductListItem = ({ product }: { product: Campaign }) => {
  const {
    id,
    product_name,
    company_name,
    total_accounts,
    last_updated_at,
    critical_titles,
    is_demo,
    user_roles,
    invited_users_count,
    is_new,
  } = product;
  const navigate = useNavigate();

  return (
    <Stack
      sx={{
        gap: "16px",
        border: is_demo ? "2px solid #2194D2" : "1px solid #D9D9D9",
        padding: "16px",
        borderRadius: "8px",
        position: "relative",
      }}
    >
      {is_demo && (
        <span
          style={{
            position: "absolute",
            top: -28,
            left: 16,
            color: "#FFFFFF",
            backgroundColor: "#2194D2",
            padding: "4px 8px",
            borderTopRightRadius: "4px",
            borderTopLeftRadius: "4px",
            fontSize: "14px",
            fontWeight: 500,
          }}
        >
          Demo
        </span>
      )}

      <Stack
        sx={{
          width: "100%",
          flexDirection: "row",
          justifyContent: "space-between",
          paddingBottom: "8px",
          borderBottom: "1px solid #D9D9D9",
        }}
      >
        <Stack gap="16px" direction="row" alignItems="center">
          <Stack gap="4px" direction="row" color="custom" alignItems="center">
            <Link
              to={`${AppRoutes.CAMPAINGS}/${id}`}
              style={{ textDecoration: "none" }}
            >
              <Typography
                variant="subtitle1"
                color="custom.textDarkBlue"
                fontWeight={500}
              >
                {product_name}
              </Typography>
            </Link>

            <Box
              sx={{
                width: "4px",
                height: "4px",
                borderRadius: "50%",
                backgroundColor: "#A9A9A9",
              }}
            />

            <Typography variant="subtitle1" color="#A9A9A9" fontWeight={500}>
              {company_name}
            </Typography>
          </Stack>
          <RolesIconsBlock
            userRoles={user_roles || []}
            isShared={invited_users_count > 1}
          />
          {is_new && <NewCampaignBlock />}
        </Stack>

        <Typography
          variant="body1"
          color="custom.textDarkBlue"
          fontWeight={500}
          sx={{ display: "flex", gap: "4px", alignItems: "center" }}
        >
          Last update:
          <Typography component="span">
            {formatDateRange(last_updated_at, true)}
          </Typography>
        </Typography>
      </Stack>

      {critical_titles.length > 0 && (
        <>
          <Typography
            variant="body1"
            color="custom.textDarkBlue"
            fontWeight={500}
          >
            Critical Job Titles
          </Typography>

          <Stack
            sx={{
              width: "100%",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: "8px",
            }}
          >
            {critical_titles.map((jobTitle, index) => (
              <Typography
                key={index}
                variant="body1"
                color="custom.textDarkBlue"
                fontWeight={500}
                sx={{
                  padding: "4px 12px",
                  borderRadius: "6px",
                  backgroundColor: "#D8DCE180",
                }}
              >
                {jobTitle}
              </Typography>
            ))}
          </Stack>
        </>
      )}

      <Stack direction="row" justifyContent="space-between">
        <Stack direction="row" gap="4px" alignItems="center">
          <CompanyIcon width="34px" height="34px" />
          <Typography
            variant="body1"
            color="custom.textDarkBlue"
            fontWeight={500}
          >
            {total_accounts} Accounts Attached
          </Typography>
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-end"
        >
          <Stack direction="row" gap="8px" minWidth="340px">
            <CustomButton
              variant="contained"
              fullWidth
              type="button"
              customColor="#1C3C6C"
              sx={{ height: "38px" }}
              onClick={() => navigate(`${AppRoutes.ACCOUNTS_LIST}/${id}`)}
            >
              View Accounts
            </CustomButton>
            <CustomButton
              variant="outlined"
              customColor="#FFFFFF"
              textColor="#1D3E70"
              fullWidth
              type="button"
              sx={{ height: "38px", borderColor: "#1D3E70" }}
              onClick={() => navigate(`${AppRoutes.CAMPAINGS}/${id}`)}
            >
              Campaign Details
            </CustomButton>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
